import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../../components';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="app">
      <Header />
      <main className="main">
        <div className="container">
          <div className="not-found-container">
            <div className="not-found-content">
              <div className="not-found-icon">🔍</div>
              <h1>404</h1>
              <h2>页面不存在</h2>
              <p>
                抱歉，您访问的页面可能已被删除、移动或暂时不可用。
              </p>
              <p>
                请检查网址是否正确，或返回首页继续浏览。
              </p>
              
              <div className="not-found-actions">
                <Link to="/" className="btn btn-primary">
                  返回首页
                </Link>
                <button 
                  onClick={() => window.history.back()}
                  className="btn btn-secondary"
                >
                  返回上一页
                </button>
              </div>
              
              <div className="not-found-suggestions">
                <h3>您可能想访问的页面：</h3>
                <ul>
                  <li>
                    <Link to="/">首页</Link>
                  </li>
                  <li>
                    <Link to="/archive">文章归档</Link>
                  </li>
                  <li>
                    <Link to="/about">关于我们</Link>
                  </li>
                  <li>
                    <Link to="/write">写文章</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;